module.exports = ".tilecontainer {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./snippets/tilesCss.html
 ** module id = 272
 ** module chunks = 0
 **/